module.exports = __webpack_public_path__ + "static/media/lc.f9bffa63.svg";